export default __webpack_public_path__ + "img/add-product.26f85cef.svg";